import React from 'react'

import { FramesManager } from '../../../view/frames-manager'

export const UI2_BANNER_DEFAULT_PROPS: Partial<UI2BannerProps> = {
  mode: 'neutral',
}

export type BannerMode = 'success' | 'info' | 'warning' | 'danger' | 'neutral'

export interface UI2BannerProps {
  /** Visual tone. Also picks a default icon when `icon` is not provided. Defaults to 'neutral'. */
  mode?: BannerMode
  title?: string
  /** Plain-text body. Ignored when `markdownText` is provided. */
  text?: string
  /** Markdown body. Takes precedence over `text` when both are set. */
  markdownText?: string
  /** Icon name override. When omitted, an icon is chosen based on `mode`. */
  icon?: string
  /** Actions/controls rendered inside the banner, below the body. */
  children?: React.ReactNode
  /**
   * Local translation table. Merged over `frames.getContext('translationTable')`
   * so component-level entries override the ambient table.
   */
  translationTable?: Record<string, string>
  /** Renderer frames; supplies the ambient translation table when present. */
  frames?: FramesManager
}
